import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { OrgDetailInitializer } from "./detailInitializer";

const OrgRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes key={org}>
        <Route index element={<Navigate to={`${org}`} />} />
        <Route path={`:org/*`} element={<OrgDetailInitializer key={org} />} />
      </Routes>
    </Layout>
  );
};

export default OrgRoute;
